import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/vendors?include=permissions&roles`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function roleLists (vendor) {
    let options = {
        paramsSerializer: function () {
            return qs.stringify({}, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/vendors/${vendor.id}/roles`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}
function get (id) {
    let options;
    let idType = typeof(id);
    if (idType !== 'object') {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            }
        };
    } else {
        options = {
            headers: {
                'Accept': 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
            },
            params: id,
            paramsSerializer: function (params) {
                return qs.stringify(params, { encode: false });
            },
        };
        id = id.id;
        delete id.id;
    }
    return axios.get(`${url}/vendors/${id}`, options)
        .then(response => {
            let vendor = jsona.deserialize(response.data);
            delete vendor.links;
            return vendor;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    return axios.get(`${url}/vendors/${id}`, options)
        .then(response => {
            let vendor = jsona.deserialize(response.data);
            delete vendor.links;
            return vendor;
        });
}

function add (vendor) {
    const payload = jsona.serialize({
        stuff: vendor,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/vendors?include=permissions`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (vendor) {
    const payload = jsona.serialize({
        stuff: vendor,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/vendors/${vendor.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/vendors/${id}`, options);
}

function upload (item, image) {
    const bodyFormData = new FormData();
    bodyFormData.append('attachment', image);

    return axios.post(`${url}/uploads/items/${item.id}/image`, bodyFormData)
        .then(response => {
            return response.data.url;
        });
}

function permissions (item, permissionsData) {
    const bodyFormData = new FormData();
    bodyFormData.append('selected', permissionsData);
    return axios.post(`${url}/vendor_permissions/vendors/${item.id}/permission`, bodyFormData)
        .then(response => {
            return response.data.sms;
        });
}

function roles (item,role_name,permissionsData) {
    const bodyFormData = new FormData();
    bodyFormData.append('selected', permissionsData);
    bodyFormData.append('role_name', role_name);
    return axios.post(`${url}/vendor_roles/vendors/${item.id}/permission`, bodyFormData)
        .then(response => {
            return response.data.sms;
        });
}
function employees (vendor) {
    console.log(vendor);
    let options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };
    return axios.get(`${url}/vendors/${vendor}/relationships/employees`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

export default {
    list,
    get,
    show,
    add,
    update,
    upload,
    roles,
    permissions,
    roleLists,
    employees,
    destroy
};

